import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TOP_PERFORMERS_SUCCESS,
  FETCH_POOR_PERFORMERS_SUCCESS,
  FETCH_CLASS_BY_TYPE_SUCCESS,
  FETCH_VISITS_BY_TYPE_SUCCESS,
  SET_CLASS_TYPES_CHECKED,
  ADD_CLASS_CHART_SUCCESS,
  REMOVE_CLASS_CATEGORY,
  REMOVE_CLASS_CATEGORY_SUCCESS,
  FETCH_ALL_CLASSES_BY_TYPE_SUCCESS
} from "./attendanceSagas";

export function getTypeValues(data) {
  let types = [];
  data.map((item) => {
    types.push(item.id);
  });

  return types;
}

export const initialState = {
  currentUser: {},
  initRequest: false,
  prevPageFilters: { prevDate: null },
  topPerformers: [],
  poorPerformers: [],
  classByTypeAttendance: [],
  allClassesByType: [],
  visitsByType: {
    percentageOfNewVisits: 0
  },
  classByTypeAttendanceChecked: {},
  classByTypeAttendanceCheckedMax: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [FETCH_TOP_PERFORMERS_SUCCESS]: (state, action) => ({
      ...state,
      topPerformers: action.payload.topPerformers || state.topPerformers
    }),
    [FETCH_POOR_PERFORMERS_SUCCESS]: (state, action) => ({
      ...state,
      poorPerformers: action.payload.poorPerformers || state.poorPerformers
    }),
    [FETCH_CLASS_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance,
      classByTypeAttendanceChecked:
        getTypeValues(action.payload.classByTypeAttendance) || state.classByTypeAttendanceChecked
    }),
    [FETCH_ALL_CLASSES_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      allClassesByType: action.payload.allClassesByType || state.allClassesByType
    }),
    [FETCH_VISITS_BY_TYPE_SUCCESS]: (state, action) => ({
      ...state,
      visitsByType: action.payload.visitsByType || state.visitsByType
    }),
    [SET_CLASS_TYPES_CHECKED]: (state, action) => ({
      ...state,
      classByTypeAttendanceChecked: action.payload.filtered || state.classByTypeAttendanceChecked,
      classByTypeAttendanceCheckedMax: action.payload.maxChecked
    }),
    [ADD_CLASS_CHART_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance
    }),
    [REMOVE_CLASS_CATEGORY]: (state, action) => ({
      ...state,
      classByTypeAttendance: state.classByTypeAttendance.filter(
        (rev) => rev.id !== action.payload.id
      )
    }),
    [REMOVE_CLASS_CATEGORY_SUCCESS]: (state, action) => ({
      ...state,
      classByTypeAttendance: action.payload.classByTypeAttendance || state.classByTypeAttendance,
      classByTypeAttendanceChecked:
        getTypeValues(action.payload.classByTypeAttendance) || state.classByTypeAttendanceChecked,
      classByTypeAttendanceCheckedMax: false
    })
  },
  initialState
);
